<div class="ppl-container-body">
  <div class="ppl-container">
    <div class="ppl-content-container" style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">
      <div class="line1">
        <div class="action">
          <ppl-button [label]="'Back'" icon="fa fa-chevron-left" (click)="goBack()"
            [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
        </div>
      </div>
      <div class="line2">
        <h2>Details for ID: {{caseManagerId}}</h2>
      </div>
      <div style="width: 100%">
        <ppl-accordion [title]="'Basic Information'" [isOpen]="true">
          <div class="wiz-body">
            <div class="ppl-mt24">
              <div class="custom-row" [authorizeButton]="[pageId, 'EditCaseManager']">
                @if(mode==="edit"){
                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onCancel()"></ppl-button>
                <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onUpdate()"></ppl-button>
                }
                @if(mode==="read"){
                <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onEdit()"></ppl-button>
                }
              </div>
              @if(mode==="edit"){
              <form nz-form [formGroup]="caseManagerForm" class="ppl-p0">
                @if(isAttrAvailable('firstName')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="firstName"
                    class="ppl-form-label">{{getAttributes('firstName').label}}
                    @if(getAttributes('firstName').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('firstName')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <input nz-input formControlName="firstName" id="firstName"
                        placeholder="{{getAttributes('firstName').placeholder}}"
                        [ngClass]="{'error': validationErrors['firstName'] }"
                        [attr.aria-invalid]="validationErrors['firstName'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['firstName'] ? 'firstName-error' : null" />
                    </div>
                    @if (validationErrors['firstName']) {
                    <span class="pl-1 error-message" id="firstName-error" role="alert">{{validationErrors['firstName']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('lastName')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lastName"
                    class="ppl-form-label">{{getAttributes('lastName').label}}
                    @if(getAttributes('lastName').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lastName')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <input nz-input formControlName="lastName" id="lastName"
                        placeholder="{{getAttributes('lastName').placeholder}}"
                        [ngClass]="{'error': validationErrors['lastName'] }" 
                        [attr.aria-invalid]="validationErrors['lastName'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['lastName'] ? 'lastName-error' : null" />
                    </div>
                    @if (validationErrors['lastName']) {
                    <span class="pl-1 error-message" id="lastName-error" role="alert">{{validationErrors['lastName']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('email') && isAttrAvailable('mobile')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="email" class="ppl-form-label">
                    Please enter Email Address or Mobile Number
                    @if(getAttributes('email').mandatory === 'Y' && getAttributes('mobile').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('email').tooltip}}"
                      nzTooltipPlacement="topRight" formControlName="email" id="email"
                      [ngClass]="{'error': validationErrors['email'] }"
                      placeholder="{{getAttributes('email').placeholder}}"
                      [attr.aria-invalid]="validationErrors['email'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['email'] ? 'email-error' : null" />
                    @if (validationErrors['email']) {
                    <span class="pl-1 error-message" id="email-error" role="alert">{{validationErrors['email']}}</span>
                    }
                    <div style="margin-top: 24px;">
                      <input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}"
                        nzTooltipPlacement="topRight" nz-input id="mobile" formControlName="mobile"
                        [ngClass]="{'error': validationErrors['mobile'] }"
                        placeholder="{{getAttributes('mobile').placeholder}}"
                        [attr.aria-invalid]="validationErrors['mobile'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['mobile'] ? 'mobile-error' : null" />
                      @if (validationErrors['mobile']) {
                      <span class="pl-1 error-message" id="mobile-error" role="alert">{{validationErrors['mobile']}}</span>
                      }
                    </div>
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('email') && !isAttrAvailable('mobile')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="email"
                    class="ppl-form-label">{{getAttributes('email').label}}
                    @if(getAttributes('email').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('email').tooltip}}"
                      nzTooltipPlacement="topRight" formControlName="email" id="email"
                      [ngClass]="{'error': validationErrors['email'] }"
                      placeholder="{{getAttributes('email').placeholder}}"
                      [attr.aria-invalid]="validationErrors['email'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['email'] ? 'emailError' : null" />
                    @if (validationErrors['email']) {
                    <span class="pl-1 error-message"  id="emailError" role="alert">{{validationErrors['email']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('mobile') && !isAttrAvailable('email')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mobile"
                    class="ppl-form-label">{{getAttributes('mobile').label}}
                    @if(getAttributes('mobile').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}" nzTooltipPlacement="topRight"
                      nz-input id="mobile" formControlName="mobile" [ngClass]="{'error': validationErrors['mobile'] }"
                      placeholder="{{getAttributes('mobile').placeholder}}"
                      [attr.aria-invalid]="validationErrors['mobile'] ? 'true' : 'false'"
                      [attr.aria-describedby]="validationErrors['mobile'] ? 'mobileError' : null" />
                    @if (validationErrors['mobile']) {
                    <span class="pl-1 error-message" id="mobileError" role="alert">{{validationErrors['mobile']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('orgName') && isAttrAvailable('ldssCode')){
                  <nz-form-item nz-col class="ppl-form-item">
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="orgName" class="ppl-form-label">
                      Please select MCO or LDSS Office
                      @if(getAttributes('orgName').mandatory === 'Y' && getAttributes('ldssCode').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control" nz-tooltip
                    nzTooltipTitle="{{getAttributes('orgName').tooltip}}" nzTooltipPlacement="topRight">
                    <div [ngClass]="{'error': validationErrors['orgName'] }">
                      <ppl-dropdown-select formControlName="orgName" id="orgName"
                          [options]="mcoEntries" [optionLabel]="'orgName'"
                          [optionValue]="'orgName'"
                          placeholder="{{getAttributes('orgName').tooltip}}"
                          [attr.aria-invalid]="validationErrors['orgName'] ? 'true' : 'false'"
                      [attr.aria-describedby]="validationErrors['orgName'] ? 'orgName-error' : null"></ppl-dropdown-select>
                  </div>
                    @if (validationErrors['orgName']) {
                    <span class="pl-1 error-message" id="orgName-error" role="alert">{{validationErrors['orgName']}}</span>
                    }
                      <div style="margin-top: 24px;">
                      <div [ngClass]="{'error': validationErrors['ldssCode'] }">
                        <ppl-dropdown-select formControlName="ldssCode" id="ldssCode"
                        [options]="ldssOfficeValues" [optionLabel]="'lkpValueName'"
                        [optionValue]="'lkpValueCode'"
                        placeholder="Please select LDSS Office"
                        [attr.aria-invalid]="validationErrors['ldssCode'] ? 'true' : 'false'"
                      [attr.aria-describedby]="validationErrors['ldssCode'] ? 'ldssCode-error' : null"></ppl-dropdown-select>
                      </div>
                      @if (validationErrors['ldssCode']) {
                      <span class="pl-1 error-message" id="ldssCode-error" role="alert">{{validationErrors['ldssCode']}}</span>
                      }
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if(isAttrAvailable('active')){
                  <nz-form-item nz-col class="ppl-form-item">
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="active"
                              class="ppl-form-label">{{getAttributes('active').label}}
                              @if(getAttributes('active').mandatory === 'Y'){
                              <span [attr.aria-label]="'Required'">*</span>
                              }
                          </nz-form-label>
                          <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                              <div nz-tooltip [nzTooltipTitle]="getAttributes('active')?.tooltip || ''"
                                  nzTooltipPlacement="topRight">
                                  <div [ngClass]="{'error': validationErrors['active'] }">
                                  <ppl-dropdown-select formControlName="active" id="active"
                                  [options]="radioOptions" [optionLabel]="'lkpValueName'"
                                  [optionValue]="'lkpValueCode'"
                                  placeholder=""
                                  [attr.aria-invalid]="validationErrors['active'] ? 'true' : 'false'"
                                  [attr.aria-describedby]="validationErrors['active'] ? 'active-error' : null"></ppl-dropdown-select>
                                </div>
                              </div>
                              @if (validationErrors['active']) {
                              <span class="pl-1 error-message" id="active-error" role="alert">{{validationErrors['active']}}</span>
                              }
                          </nz-form-control>
                  </nz-form-item>
                  }
              </form>
              }
              @else if (mode==="read") {
              <div nz-row>
                @if(isAttrAvailable('firstName')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("firstName").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.firstName }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('lastName')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("lastName").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lastName }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('email')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("email").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.email }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('mobile')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("mobile").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.mobile }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('orgName')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("orgName").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.orgName }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('ldssCode')){
                  <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{getAttributes('ldssCode').label}} 
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.ldssOffice }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('active')){
                  <div nz-col nzSpan="12">
                    <div nz-row>
                      <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                        {{ getAttributes("active").label }}
                      </div>
                      <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.active }}</div>
                    </div>
                  </div>
                  }
              </div>
              }
            </div>
          </div>
        </ppl-accordion>
      </div>
    </div>
  </div>
</div>